import { DefaultValue } from 'recoil';

export const guardRecoilDefaultValue = (candidate: unknown): candidate is DefaultValue => {
    return candidate instanceof DefaultValue;
};
